<template>
	<div class="flex flex_center">
		<div :style="baseStyle">
			<div class="flex flex_center flex_column">
				<slot></slot>
			</div>
			<div class="margin_top flex" :class="hasPreviousStep ? 'flex_between' : 'flex_center'">
				<md-button v-if="hasPreviousStep" class="md-blank leftBtn" @click="back()">
					{{ $t("common.button.back") }}
				</md-button>
				<md-button v-if="hasNextStep" :class="{'md-primary': isFormValid}" class="" @click="validateAndNext()">
					{{ $t("common.button.next") }}
				</md-button>
				<md-button v-if="!hasNextStep" :class="{'md-primary': isFormValid}" class="" @click="validateAndSubmit()">
					{{ $t("common.button.submit") }}
				</md-button>
			</div>
		</div>
	</div>
</template>

<script>
import {signUpTrackingApi} from "@/common/api/signUpTracking";
import {mapActions, mapGetters} from "vuex";
import {enumDef} from "@/common/enumDefs";
import {validateForm, validateRequiredFields} from "@/validation/validation";
import {registrationApi} from "@/common/api/registrationApi";

export default {
	props: {
		content: { type: Object },
		minWidth: { type: String, default: "30%" },
		maxWidth: { type: String, default: "40%" }
	},
	created() {
		signUpTrackingApi.trackNextStep(this.currentStep);

		if (this.content.shouldBeSkipped) {
			this.moveSteps(this.currentStep > this.signUpCurrentStep ? +1 : -1);
		} else {
			this.setSignUpStepActive(this.currentStep);
		}
	},
	computed: {
		...mapGetters({
			signUpData: "local/signUpData",
			signUpSettings: "local/signUpSettings",
			signUpCurrentStep: "local/signUpCurrentStep",
			signUpCredentials: "signUpCredentials"
		}),
		baseStyle() {
			return "min-width: " + this.minWidth + "; max-width: " + this.maxWidth + ";";
		},
		currentStep() {
			return enumDef.signUpStep.forPath(this.$route.path);
		},
		currentStepOrderIndex() {
			return this.stepOrder.indexOf(this.currentStep);
		},
		stepOrder() {
			return enumDef.signUpStep.orderedList();
		},
		hasNextStep() {
			return this.stepOrder.length > this.currentStepOrderIndex + 1;
		},
		hasPreviousStep() {
			return this.currentStepOrderIndex - 1 >= 0;
		},
		isFormValid() {
			if (this.content.useCustomFormValidation) {
				return this.content.isFormValid;
			}

			return validateRequiredFields(this.content.form || {}, this.content.modelValidations || {});
		},
		formValidation() {
			return this.content.useCustomFormValidation ? this.content.validateForm : () => validateForm(this, this.content.$validator);
		},
		dataValidation() {
			return this.content.validateData || (() => Promise.resolve());
		},
		confirmationCheck() {
			return this.content.confirmNext || (() => Promise.resolve());
		},
		beforeNextAction() {
			return this.content.beforeNext || (() => Promise.resolve());
		},
	},
	methods: {
		...mapActions({
			setSignUpStepActive: "local/setSignUpStepActive",
			setSignUpStepCompleted: "local/setSignUpStepCompleted",
			updateSignUpData: "local/updateSignUpData",
			setSignUpRedirect: "local/setSignUpRedirect",
			clearSignUp: "local/clearSignUp"
		}),
		validateAndNext() {
			this.formValidation()
				.then(this.dataValidation)
				.then(this.next)
				.catch(this.toast);
		},
		validateAndSubmit() {
			this.formValidation()
				.then(this.submit)
				.catch(this.toast);
		},
		next() {
			this.confirmationCheck()
				.then(this.beforeNextAction)
				.then(() => {
					this.updateSignUpData(this.content.form);
					this.setSignUpStepCompleted(this.currentStep);
					this.moveSteps(+1);
				});
		},
		back() {
			this.moveSteps(-1);
		},
		submit() {
			this.confirmationCheck().then(() => {
				registrationApi.submitInitialRegistration({
					...this.signUpData,
					...this.signUpCredentials
				})
				.then((res) => {
					this.setSignUpRedirect(res || {});
					this.$router.push(enumDef.signUpStep.path(enumDef.signUpStep.Completion));
				})
				.catch(this.toast);
			});
		},
		moveSteps(offset) {
			const nextStep = this.stepOrder[this.currentStepOrderIndex + offset];
			this.$router.push(enumDef.signUpStep.path(nextStep));
		},
	}
};
</script>